function formatDate(timeStampInfo) {
  // format timestamp date
  // handles when timeStampInfo is an object and we need to access updatedAt
  // also handles when we receive timeStampInfo as just a string with a timestamp
  const options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/New_York',
  };

  try {
    let datetime;
    if (typeof timeStampInfo === 'string') {
      datetime = timeStampInfo;
    } else {
      datetime = timeStampInfo.updatedAt;
    }
    if (!datetime) {
      return null;
    }
    datetime = new Date(datetime);
    const formatteddatetime = `${datetime.toLocaleDateString(
      'en-US',
      options,
    )} EST`;
    return formatteddatetime;
  } catch (e) {
    return null;
  }
}

function currencyFormatter(currency) {
  /**
   * Format plain number to USD currency
   * @param {number} currency - number to format
   * @returns {string} - formatted currency
   */
  try {
    if (currency === 0) {
      return '$0.00';
    }
    if (!currency) {
      return currency;
    }
    const formatter = Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    return formatter.format(currency);
  } catch (err) {
    return currency;
  }
}

function formatDropDownValues(attribute, val) {
  /**
   * Custom logic for Dropdown fields to format database values into user friendly values
   * @param {number} attribute - attribute name
   * @param {string} val - value to format
   * @returns {string} - formatted value for dropdown
   */
  if (attribute === 'donor_category') {
    if (val.includes('nonprofit')) {
      return val
        .replace(/_/g, ' ')
        .replace(/nonprofit/gi, 'Non-Profit')
        .replace(/\b\w/g, (c) => c.toUpperCase());
    } if (val === 'cross_sector') {
      return val
        .replace(/cross_sector/gi, 'Cross-Sector')
        .replace(/\b\w/g, (c) => c.toUpperCase());
    }
    return val.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  }
  if (attribute === 'donor_config_type') {
    if (!(val.includes('Select'))) {
      return `${val.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}`;
    }
  }
  return val;
}

function getAndFormat30DaysAgo() {
  // get date 30 days ago from today to use as default criteria for advanced search
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(today.getDate() - 30);
  // convert Date object to "YYYY-MM-DD" string
  const thirtyDaysAgoString = thirtyDaysAgo.toISOString().split('T')[0];
  return thirtyDaysAgoString;
}

export {
  formatDate,
  currencyFormatter,
  formatDropDownValues,
  getAndFormat30DaysAgo,
};
